// A compass that visually replaces the "O" in FORWARD.
// Outer ring stays static (so the silhouette still reads as an O).
// The 4-point needle inside slowly rotates to give a sense of direction & life.
export default function CompassO({ size = 64, rotate = true, color = "var(--gold-500)" }) {
  const s = size;
  return (
    <span
      className="compass-o relative inline-flex items-center justify-center align-baseline"
      style={{
        width: s,
        height: s,
        // Visually align with cap-height of the surrounding display font.
        verticalAlign: "baseline",
        transform: "translateY(0.12em)",
      }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 100 100"
        width={s}
        height={s}
        style={{ display: "block", overflow: "visible" }}
      >
        {/* Outer ring — this is the "O" */}
        <circle cx="50" cy="50" r="46" fill="none" stroke={color} strokeWidth="8" />
        {/* Inner thin ring */}
        <circle cx="50" cy="50" r="36" fill="none" stroke={color} strokeWidth="1.5" opacity="0.55" />

        {/* Compass needle group — rotates */}
        <g
          style={{
            transformOrigin: "50px 50px",
            animation: rotate ? "twf-compass-spin 32s linear infinite" : "none",
          }}
        >
          {/* North needle (filled gold) */}
          <polygon points="50,16 56,50 50,46 44,50" fill={color} />
          {/* South needle (outline) */}
          <polygon
            points="50,84 56,50 50,54 44,50"
            fill="none"
            stroke={color}
            strokeWidth="2"
          />
          {/* East/West thin marks */}
          <line x1="20" y1="50" x2="32" y2="50" stroke={color} strokeWidth="2" opacity="0.7" />
          <line x1="68" y1="50" x2="80" y2="50" stroke={color} strokeWidth="2" opacity="0.7" />
          {/* Centre pivot */}
          <circle cx="50" cy="50" r="3.2" fill={color} />
        </g>
      </svg>
    </span>
  );
}
